/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { ComplimentaryAction } from "../../../complimentary_actions/complimentary_actions";

export const protobufPackage = "skills";

export interface RegisterComplimentaryActionsActionArgs {
  complimentaryActionsToRegister: ComplimentaryAction[];
  timeoutS: number;
}

export interface RegisterComplimentaryActionsResultData {
}

export interface RegisterComplimentaryActionsActionStateData {
}

function createBaseRegisterComplimentaryActionsActionArgs(): RegisterComplimentaryActionsActionArgs {
  return { complimentaryActionsToRegister: [], timeoutS: 0 };
}

export const RegisterComplimentaryActionsActionArgs = {
  encode(message: RegisterComplimentaryActionsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.complimentaryActionsToRegister) {
      ComplimentaryAction.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeoutS !== 0) {
      writer.uint32(21).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterComplimentaryActionsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterComplimentaryActionsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.complimentaryActionsToRegister.push(ComplimentaryAction.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterComplimentaryActionsActionArgs {
    return {
      complimentaryActionsToRegister: globalThis.Array.isArray(object?.complimentaryActionsToRegister)
        ? object.complimentaryActionsToRegister.map((e: any) => ComplimentaryAction.fromJSON(e))
        : [],
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
    };
  },

  toJSON(message: RegisterComplimentaryActionsActionArgs): unknown {
    const obj: any = {};
    if (message.complimentaryActionsToRegister?.length) {
      obj.complimentaryActionsToRegister = message.complimentaryActionsToRegister.map((e) =>
        ComplimentaryAction.toJSON(e)
      );
    }
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterComplimentaryActionsActionArgs>, I>>(
    base?: I,
  ): RegisterComplimentaryActionsActionArgs {
    return RegisterComplimentaryActionsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterComplimentaryActionsActionArgs>, I>>(
    object: I,
  ): RegisterComplimentaryActionsActionArgs {
    const message = createBaseRegisterComplimentaryActionsActionArgs();
    message.complimentaryActionsToRegister =
      object.complimentaryActionsToRegister?.map((e) => ComplimentaryAction.fromPartial(e)) || [];
    message.timeoutS = object.timeoutS ?? 0;
    return message;
  },
};

function createBaseRegisterComplimentaryActionsResultData(): RegisterComplimentaryActionsResultData {
  return {};
}

export const RegisterComplimentaryActionsResultData = {
  encode(_: RegisterComplimentaryActionsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterComplimentaryActionsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterComplimentaryActionsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RegisterComplimentaryActionsResultData {
    return {};
  },

  toJSON(_: RegisterComplimentaryActionsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterComplimentaryActionsResultData>, I>>(
    base?: I,
  ): RegisterComplimentaryActionsResultData {
    return RegisterComplimentaryActionsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterComplimentaryActionsResultData>, I>>(
    _: I,
  ): RegisterComplimentaryActionsResultData {
    const message = createBaseRegisterComplimentaryActionsResultData();
    return message;
  },
};

function createBaseRegisterComplimentaryActionsActionStateData(): RegisterComplimentaryActionsActionStateData {
  return {};
}

export const RegisterComplimentaryActionsActionStateData = {
  encode(_: RegisterComplimentaryActionsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterComplimentaryActionsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterComplimentaryActionsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RegisterComplimentaryActionsActionStateData {
    return {};
  },

  toJSON(_: RegisterComplimentaryActionsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterComplimentaryActionsActionStateData>, I>>(
    base?: I,
  ): RegisterComplimentaryActionsActionStateData {
    return RegisterComplimentaryActionsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterComplimentaryActionsActionStateData>, I>>(
    _: I,
  ): RegisterComplimentaryActionsActionStateData {
    const message = createBaseRegisterComplimentaryActionsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
